import { render, staticRenderFns } from "./left.sidebar.component.vue?vue&type=template&id=44a70e5f&scoped=true&"
import script from "./left.sidebar.component.vue?vue&type=script&lang=js&"
export * from "./left.sidebar.component.vue?vue&type=script&lang=js&"
import style0 from "./left.sidebar.component.vue?vue&type=style&index=0&id=44a70e5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a70e5f",
  null
  
)

export default component.exports